import { gql } from '@common/hooks';
import { SimpleFileFragment, SimpleFileFragmentType } from '@common/graphql';
import { InvoiceReviewFragment } from '@pay-bill/graphql/fragments';

export const WorksInvoiceExportMutation = gql`
  mutation CreateWorksInvoiceExportMutation(
    $id: ID!
    $format: WorksInvoiceFileFormat!
  ) {
    result: createWorksInvoiceExport(input: { id: $id, format: $format }) {
      success
    }
  }
`;

export const WorksInvoicePdfExportMutation = gql`
  mutation createWorksInvoicePdf($id: ID!, $type: String!) {
    result: createWorksInvoicePdf(input: { invoiceId: $id, type: $type }) {
      file {
        ...SimpleFileFragment
      }
    }
  }
  ${SimpleFileFragment}
`;

export type PdfExportFileArgs = {
  id: string;
  type?: string;
};

export type PdfExportFileResponse = {
  result: {
    file: SimpleFileFragmentType;
  };
};

export const PerformWorksInvoiceAction = gql`
  mutation PerformWorksInvoiceAction(
    $invoiceIds: [ID!]!
    $action: WorksInvoiceActions!
  ) {
    performWorksInvoiceAction(invoiceIds: $invoiceIds, action: $action) {
      worksInvoices {
        ...InvoiceReviewFragment
      }
    }
  }
  ${InvoiceReviewFragment}
`;

export const WorksInvoiceMultipleExportMutation = gql`
  mutation CreateWorksInvoiceMultipleExport(
    $entityIds: [ID!]!
    $format: WorksInvoiceFileFormat!
  ) {
    result: createWorksInvoiceMultipleExport(
      input: { entityIds: $entityIds, format: $format }
    ) {
      file: exportFile {
        ...SimpleFileFragment
      }
    }
  }
  ${SimpleFileFragment}
`;
